import { Injectable, OnDestroy } from "@angular/core";
import { Qualifier } from "app/shared/model";
import { Subject, Subscription } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class VisibilityService implements OnDestroy {
    protected _watchers: Array<{ sub: Subscription, controlNameInitiator: string, pathInitiator: Qualifier }> = [];
    private readonly ngDestroy: Subject<any> = new Subject();

    get ngDestroy$() {
        return this.ngDestroy.asObservable();
    }

    ngOnDestroy() {
        this.unsubscribeAll();
        this.ngDestroy.next(null);
    }

    subscribe(sub: Subscription, controlNameInitiator: string, pathInitiator: Qualifier) {
        this._watchers.push({ sub: sub, controlNameInitiator: controlNameInitiator, pathInitiator: pathInitiator });
    }

    unsubscribeAll() {
        this._watchers.forEach(subObj => {
            subObj?.sub?.unsubscribe();
        })

        this._watchers = [];
    }

    unsubscribeByProp(path: Qualifier, initiatorName: string) {
        if (initiatorName) {
            return;
        }

        path = path || new Qualifier();
        let arr = [];

        this._watchers.forEach(subObj => {
            if ((subObj.pathInitiator || new Qualifier()).toString() === path.toString() &&
                subObj.controlNameInitiator === initiatorName) {
                subObj?.sub?.unsubscribe();
                return;
            }

            arr.push(subObj);
        })

        this._watchers = arr;
    }
}
